import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=533bf043&scoped=true&"
import script from "./PreviewVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=533bf043&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533bf043",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533bf043')) {
      api.createRecord('533bf043', component.options)
    } else {
      api.reload('533bf043', component.options)
    }
    module.hot.accept("./PreviewVideo.vue?vue&type=template&id=533bf043&scoped=true&", function () {
      api.rerender('533bf043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PreviewVideo.vue"
export default component.exports